<template>
  <div>
    <b-row>
      <b-col align-self="center" sm="1">
        <b-form-checkbox
            :id="`check-pic-${picSelected.picid}`"
            :checked="checkedPicComp"
            @change="handleCheckPic"
        >
        </b-form-checkbox>
      </b-col>
      <b-col align-self="center">
        <b-card
          no-body
          :class="{'open': visible}"
          class="business-card"
          @mouseenter="collapseOpen"
          @mouseleave="collapseClose"
          style="border: 1px solid #ebe9f1; border-radius: .357rem;"
      >
        <b-card-header
            :class="[
              !visible && 'collapsed',
              classHeaderCollapse
            ]"
            :aria-expanded="visible ? 'true' : 'false'"
            :aria-controls="collapseItemID"
            role="tab"
            data-toggle="collapse"
            @click="updateVisible(!visible)"

        >
          <slot name="header">
            <div>
              <feather-icon
                  v-if="icon"
                  :icon="icon"
                  class="mr-50 text-white"
              />

              <span class="lead collapse-title font-weight-bolder text-primary ">{{ title }}</span>
              <b-badge
                  v-if="countFields > 0"
                  variant="danger" class="ml-1">
                {{countFields}}
              </b-badge>
            </div>
          </slot>
        </b-card-header>

        <b-collapse
            :id="collapseItemID"
            v-model="visible"
            :accordion="accordion"
            role="tabpanel"
        >
          <b-card-body>
            <slot />
          </b-card-body>
        </b-collapse>
      </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCollapse,
} from 'bootstrap-vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
      require: false,
    },
    idCollapse: {
      type: String,
      default: null,
      require: false,
    },
    classHeaderCollapse: {
      type: String,
      default: null,
      require: false,
    },
    countFields: {
      type: Number,
      default: 0,
      require: false,
    },
    picSelected: {
      type: Object,
      default: null,
      require: false,
    },
    checkedPic: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
  data() {
    return {
      visible: false,
      collapseItemID: '',
      openOnHover: this.$parent.hover,
      selected: false,
    };
  },
  computed: {
    accordion() {
      return this.$parent.accordion ? `accordion-${this.$parent.collapseID}` : null;
    },
    checkedPicComp: {
      get() {
        return this.picSelected.checked;
      },
      set(value) {
        this.picSelected.checked = value;
      },
    },
  },
  created() {
    this.collapseItemID = !this.idCollapse ? uuidv4() : this.idCollapse;
    this.visible = this.isVisible;
  },
  methods: {
    updateVisible(val = true) {
      this.visible = val;
      this.$emit('visible', val);
    },
    handleCheckPic(event) {
      this.$emit('check-pic', {
        picSelected: this.picSelected,
        checked: event,
      });
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true);
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false);
    },
  },
};
</script>

<!--<template>-->
<!--  <b-card-->
<!--      no-body-->
<!--      class="business-card"-->
<!--  >-->
<!--    <b-card-body>-->
<!--      <div class="business-items">-->
<!--        <div-->
<!--            class="business-item"-->
<!--        >-->
<!--          <div class="d-flex align-items-center justify-content-between">-->
<!--            <b-form-checkbox :checked="true">-->
<!--              Option #1-->
<!--            </b-form-checkbox>-->
<!--            <b-badge variant="businessItem.badgeColor">-->
<!--              +$199-->
<!--            </b-badge>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </b-card-body>-->
<!--  </b-card>-->
<!--</template>-->

<!--<script>-->
<!--import {-->
<!--  BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BFormCheckbox, BBadge, BButton,-->
<!--} from 'bootstrap-vue'-->
<!--import Ripple from 'vue-ripple-directive'-->

<!--export default {-->
<!--  components: {-->
<!--    BCard,-->
<!--    BBadge,-->
<!--    BButton,-->
<!--    BCardHeader,-->
<!--    BCardTitle,-->
<!--    BCardBody,-->
<!--    BCardText,-->
<!--    BFormCheckbox,-->
<!--  },-->
<!--  directives: {-->
<!--    Ripple,-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--    }-->
<!--  },-->
<!--}-->
<!--</script>-->
